<template>
  <div class='input-group'>
    <span class='input-group-btn'>
      <button class='btn btn-default' type='button' @click.prevent="decreaseValue"><i class='glyphicon glyphicon-minus'></i></button>
    </span>
    <input
      class='form-control'
      v-model="value"
      type="number"
      :id="inputId"
      :name="inputName"
    />
    <span class='input-group-btn'>
      <button class='btn btn-default' type='button' @click.prevent="increaseValue"><i class='glyphicon glyphicon-plus'></i></button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    'inputName': {
      type: String,
      required: true,
    },
    'inputId': {
      type: String,
      required: true,
    },
    'initValue': {
      type: Number,
      required: false,
    },
  },
  name: 'NumberInput',
  data() {
    return {
      // define the default value
      value: this.initValue,
    }
  },

  methods: {
    increaseValue: function() {
      this.value += 1
    },
    decreaseValue: function() {
      this.value -= 1
    }
  }
}
</script>
